import getCdnImg from './getCdnImg';

const getCdnBoostImg = (handle: string, ext = '.svg') =>
  getCdnImg(`casino-boosts/${handle}`, ext);

export default getCdnBoostImg;
